import { Button, Card, List, Popconfirm, Space, Input } from "antd";
import { useState, useEffect } from "react";
import { REGEX } from "../utils/Regex";
import { useUserStore } from "../../stores/userStore";
import Router from "..";

export const InfluencerManagementContent = () => {
  const { userInfo } = useUserStore();
  const [invitedCreatorEmail, setInvitedCreatorEmail] = useState("");
  const [creatorEmailError, setCreatorEmailError] = useState("");
  const [invitedCreatorList, setInvitedCreatorList] = useState([]);
  const [creatorList, setCreatorList] = useState([]);
  const canManage = userInfo?.type_info?.grade !== "viewer";
  const [requestingId, setRequestingId] = useState(null);

  const getCreatorList = async () => {
    const res = await Router.Api.getCreatorsByAgency();
    const creators = res?.result ?? [];
    setCreatorList(creators);
  };

  const getInvitedCreators = async () => {
    const res = await Router.Api.getInvitedCreators();
    const creators = res?.result ?? [];
    setInvitedCreatorList(creators);
  };

  useEffect(() => {
    if (userInfo?.type_info?.company_id && canManage) {
      getCreatorList();
      getInvitedCreators();
    }
  }, [userInfo, canManage]);

  const onChangeInvitedCreator = (e) => {
    setInvitedCreatorEmail(e.target.value);
    setCreatorEmailError("");
  };

  const handleInviteCreator = async () => {
    if (!invitedCreatorEmail) {
      setCreatorEmailError("이메일을 입력해주세요");
      return;
    }
    if (!REGEX.email.test(invitedCreatorEmail)) {
      setCreatorEmailError("올바른 이메일 형식을 입력해주세요");
      return;
    }

    setCreatorEmailError("");

    const res = await Router.Api.inviteCreator(invitedCreatorEmail);
    if (res) {
      setInvitedCreatorEmail("");
      getInvitedCreators();
      getCreatorList();
    }
  };

  const handleCancelCreatorInvite = async (id) => {
    if (!id) return;

    const res = await Router.Api.cancelInvitedCreators(id);
    if (res) {
      getInvitedCreators();
    }
  };

  const handleDeleteCreator = async (user_id) => {
    const res = await Router.Api.deleteCreator(user_id);
    if (res) {
      getCreatorList();
    }
  };

  const handleRequestSocialAuth = async (user_id) => {
    if (requestingId === user_id) return;
    setRequestingId(user_id);

    await Router.Api.requestSocialAuth(user_id);
    setRequestingId(null);
  };

  return (
    <div>
      {/* 크리에이터 목록 - 모든 권한 조회 가능 */}
      <Card
        title="크리에이터 목록"
        className="w-full border border-[#d9d9d9] rounded-[10px] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)] mb-[30px]"
      >
        <div>
          {creatorList.length > 0 ? (
            <List
              dataSource={creatorList}
              renderItem={(item) => (
                <List.Item
                  className="text-lg md:text-xl"
                  actions={
                    canManage
                      ? [
                          !(
                            item.tiktok_influencer_id ||
                            item.youtube_influencer_id ||
                            item.instagram_influencer_id
                          ) ? (
                            <Button
                              key="request-social-certification"
                              type="link"
                              className="text-lg md:text-xl"
                              onClick={() =>
                                handleRequestSocialAuth(item.user_id)
                              }
                              loading={requestingId === item.user_id}
                            >
                              소셜 인증 요청
                            </Button>
                          ) : (
                            <Button
                              key="social-certification-completed"
                              className="text-lg md:text-xl text-gray-500"
                              type="ghost"
                              disabled
                            >
                              소셜 인증 완료
                            </Button>
                          ),
                          <Popconfirm
                            key="delete-creator"
                            title="크리에이터를 제외하시겠습니까?"
                            onConfirm={() => handleDeleteCreator(item.user_id)}
                            okText="예"
                            cancelText="아니오"
                          >
                            <Button
                              type="link"
                              danger
                              className="text-lg md:text-xl"
                            >
                              삭제
                            </Button>
                          </Popconfirm>,
                        ]
                      : []
                  }
                >
                  <List.Item.Meta
                    title={
                      <div className="flex items-center justify-start">
                        <div className="text-xl md:text-2xl font-medium whitespace-nowrap">
                          {item.nickname ||
                            item.first_name + " " + item.last_name}
                        </div>
                      </div>
                    }
                    description={
                      <div className="flex justify-between items-center text-lg md:text-xl">
                        <span>{item.email}</span>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          ) : (
            <div className="p-5 text-center text-[#999]">
              등록된 크리에이터가 없습니다.
            </div>
          )}
        </div>
      </Card>

      {/* 크리에이터 초대 현황 */}
      {canManage && (
        <Card
          title="크리에이터 초대 현황"
          className="w-full border border-[#d9d9d9] rounded-[10px] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)] mb-[30px]"
        >
          <Space.Compact className="w-full">
            <Input
              placeholder="초대할 크리에이터의 이메일을 입력하세요"
              value={invitedCreatorEmail}
              onChange={onChangeInvitedCreator}
              status={creatorEmailError ? "error" : ""}
            />
            <Button
              type="primary"
              onClick={handleInviteCreator}
              className="bg-[#171717] border-[#171717] hover:!bg-[#171717] hover:!border-[#171717]"
            >
              초대하기
            </Button>
          </Space.Compact>
          {creatorEmailError && (
            <div className="text-[#ff4d4f] mt-1 text-xl">
              {creatorEmailError}
            </div>
          )}

          {/* 초대한 크리에이터 목록 */}
          <div className="mt-5">
            <p className="m-0 mb-4 text-[15px] font-semibold">
              초대한 크리에이터 목록
            </p>
            {invitedCreatorList.length > 0 ? (
              <List
                dataSource={invitedCreatorList}
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <Popconfirm
                        key="cancel-invite"
                        title="초대를 취소하시겠습니까?"
                        onConfirm={() => handleCancelCreatorInvite(item.id)}
                        okText="예"
                        cancelText="아니오"
                      >
                        <Button type="link" danger>
                          취소
                        </Button>
                      </Popconfirm>,
                    ]}
                  >
                    <List.Item.Meta
                      title={item.user_email}
                      description={`초대일: ${
                        item.created_at?.split(" ")[0] || ""
                      }`}
                    />
                  </List.Item>
                )}
              />
            ) : (
              <div className="p-5 text-center text-[#999]">
                초대한 크리에이터가 없습니다.
              </div>
            )}
          </div>
        </Card>
      )}
    </div>
  );
};
